import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import type React from 'react';
import useCurrentEntity from '../../hooks/use-current-entity';
export type WithEntityProps = {
  entity: Entity;
};
const withEntity = <P extends WithEntityProps,>(WrappedComponent: React.ComponentType<P>): React.FC<Omit<P, keyof WithEntityProps>> => {
  const WithEntityHOC = props => {
    const $ = _c(3);
    const {
      data
    } = useCurrentEntity();
    let t0;
    if ($[0] !== data || $[1] !== props) {
      t0 = data ? <WrappedComponent {...props as P} entity={data} /> : null;
      $[0] = data;
      $[1] = props;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  };
  return WithEntityHOC;
};
export default withEntity;